import React from 'react';

export const FocusTrapContext = React.createContext<(isFocusTrapped: boolean) => void>(() => null);
